import "antd/dist/antd.css";
import {
  //useContractLoader,
  useUserProviderAndSigner,
} from "eth-hooks";
import React, { useCallback, useEffect, useState } from "react";
/*
import {
  Route,
  Switch,
  useLocation
} from "react-router-dom";*/
import { Header } from "./components";
import { NETWORKS } from "./constants";
import deployedContracts from "./contracts/hardhat_contracts.json";
import {
  Web3ModalSetup,
  //Transactor,
} from "./helpers";
import MintPage from "./views/MintPage";

import "./App.scss";

const { ethers } = require("ethers");

// 📡 What chain are your contracts deployed to?
const initialNetwork = NETWORKS.mainnet; // <------- select your target frontend network (localhost, rinkeby, xdai, mainnet)

// 😬 Sorry for all the console logging
const DEBUG = false;

let web3Modal;

function App(props) {
  // specify all the chains your app is available on. Eg: ['localhost', 'mainnet', ...otherNetworks ]
  // reference './constants.js' for other networks
  const networkOptions = [initialNetwork.name, "mainnet", "rinkeby"];

  const [injectedProvider, setInjectedProvider] = useState();
  const [address, setAddress] = useState();
  //const [writeContracts, setWriteContracts] = useState({});
  const selectedNetwork = networkOptions[0];
  //const location = useLocation();

  const targetNetwork = NETWORKS[selectedNetwork];

  // 🔭 block explorer URL
  const blockExplorer = targetNetwork.blockExplorer;

  if (DEBUG) console.log(`Using ${selectedNetwork} network`);

  const logoutOffWeb3Modal = async () => {
    await web3Modal.clearCachedProvider();
    if (injectedProvider && injectedProvider.provider && typeof injectedProvider.provider.disconnect == "function") {
      await injectedProvider.provider.disconnect();
    }
    setTimeout(() => {
      window.location.reload();
    }, 1);
  };

  // Use your injected provider from 🦊 Metamask or if you don't have it then instantly generate a 🔥 burner wallet.
  const userProviderAndSigner = useUserProviderAndSigner(injectedProvider);  
  const userSigner = userProviderAndSigner.signer;

  useEffect(() => {
    async function getAddress() {
      if (userSigner) {
        const newAddress = await userSigner.getAddress();
        setAddress(newAddress);
      }
    }
    getAddress();
  }, [userSigner]);

  // You can warn the user if you would like them to be on a specific network
  //const localChainId = localProvider && localProvider._network && localProvider._network.chainId;
  const selectedChainId =
    userSigner && userSigner.provider && userSigner.provider._network && userSigner.provider._network.chainId;

  let METH;
  let writeContracts = {};

  if(
    deployedContracts[selectedChainId] &&
    deployedContracts[selectedChainId][selectedNetwork] &&
    deployedContracts[selectedChainId][selectedNetwork].contracts &&
    deployedContracts[selectedChainId][selectedNetwork].contracts.METH
  ) {
    const contractInfo = deployedContracts[selectedChainId][selectedNetwork].contracts.METH;
    METH = new ethers.Contract(contractInfo.address, contractInfo.abi, userSigner);
  }
  writeContracts = {
    METH
  };

  //
  // 🧫 DEBUG 👨🏻‍🔬
  //
  useEffect(() => {
    if (
      DEBUG &&
      address &&
      selectedChainId
    ) {
      console.log("_____________________________________ 🏗 scaffold-eth _____________________________________");
      //console.log("🏠 localChainId", localChainId);
      console.log("👩‍💼 selected address:", address);
      console.log("🕵🏻‍♂️ selectedChainId:", selectedChainId);
    }
  }, [
    address,
    selectedChainId,
    //localChainId,
  ]);

  const loadWeb3Modal = useCallback(async () => {
    const provider = await web3Modal.connect();
    setInjectedProvider(new ethers.providers.Web3Provider(provider));

    provider.on("chainChanged", chainId => {
      setInjectedProvider(new ethers.providers.Web3Provider(provider));
    });

    provider.on("accountsChanged", () => {
      setInjectedProvider(new ethers.providers.Web3Provider(provider));
    });

    // Subscribe to session disconnection
    provider.on("disconnect", (code, reason) => {
      logoutOffWeb3Modal();
    });
    // eslint-disable-next-line
  }, [setInjectedProvider]);

  useEffect(() => {
    if(!web3Modal) {
      web3Modal = Web3ModalSetup()
    }
    if (web3Modal.cachedProvider) {
      loadWeb3Modal();
    }
  }, [loadWeb3Modal]);

  return (
    <div className="App">
      <div className="container">
        <Header
          address={address}
          userSigner={userSigner}
          web3Modal={web3Modal}
          loadWeb3Modal={loadWeb3Modal}
          logoutOfWeb3Modal={logoutOffWeb3Modal}
          blockExplorer={blockExplorer}
        />
        <div className="content">
          <section>
            <p>
              METH is an insolvent wrapper for ETH, built on the WETH smart contract code, but before we get into what that means, we need to talk about WETH first.
            </p>
          </section>

          <hr/>
          
          <section>
            <h1>The Why and What of Wrapped Tokens</h1>
            <p>
              WETH stands for “wrapped ether” and, like other wrapper tokens, it allows a non-ERC20 token, in this case ether) to be treated as if it were an ERC20 token. WBTC, which wraps Bitcoin, is another example.
            </p>
            <p>
              Why do we want to represent these non-ERC20 assets as ERC20s? Because Defi is built on the ERC20 standard. It is much easier to deploy a wrapper for a non-ERC20 asset and have it be universally compatible in one fell swoop than it is to have every Defi application code in special cases for each non-ERC20 asset.
            </p>
            <p>
              WETH's smart contract is very simple. It has three basic responsibilities that it needs to accomplish, and it does them in 62 lines of code. They are:
            </p>
            <ol>
              <li>Implement ERC20</li>
              <li>Allow ETH to be exchanged 1:1 for WETH</li>
              <li>Allow WETH to be exchanged 1:1 for ETH</li>
            </ol>

            <p className="center">
              <img src="images/weth-contract.png" alt="weth contract"/>
            </p>


            <p>
              WBTC is a different beast. Because BTC is not on the Ethereum chain at all, wrapping it requires a custodian: BitGo. You deposit native BTC with BitGo, and they issue you an equivalent amount of wBTC on Ethereum. If you want to go back to BTC, you can send BitGo your wBTC, and they will give you BTC.
            </p>
          </section>

          <hr/>

          <section>
            <h1>The Witch Hunt</h1>
            <p>
              In the fallout of FTX, the crypto community began pointing at every centralized service and yelling, “Insolvent!” In some cases they were correct. In others they were not. Eventually Crypto Twitter suggested that BitGo might not have all of the BTC it was supposed to be custodying, meaning if a sufficient number of wBTC was redeemed, BitGo would not be able to honor all of those requests. The consequence of this is that wBTC should actually be worth less than 1:1 BTC, which would be quite bad for anyone holding what they thought was an asset equivalent to BTC.
            </p>
            <p>
              These allegations were unfounded. BitGo, it seems, is fine, but caught in the crossfire was WETH. One alleger (in a now-deleted tweet) said they would not trust WBTC or WETH until they were proved to be fully backed. 
            </p>
            <p>
              This set crypto OGs into a fit of laughter and meme-making. WETH is a shining example of trustlessness. WETH cannot be insolvent because the only way for WETH to be created is by depositing ETH into the WETH contract, and the only way ETH can be removed from the contract is by redeeming WETH.
            </p>
            <p>
              The concern that a centralized company could run away with customer funds or otherwise lose access to them is one of the use cases that crypto is meant to solve and WETH, in its own very localized way, solves stupendously well.
            </p>
            <p>
              Vitalik recently wrote about ways that centralized services could prove their solvency, saying we could explore the entire spectrum between the "don't be evil" and "can't be evil." As long as there is a human element there is a chance user funds could be lost, be it by evil, negligence, or theft, but once things are coded into a smart contract the funds can only follow the rules of the contract, and the contract can't be evil or negligent with user funds... or can it.
            </p>
          </section>
          
          <hr/>

          <section>
            <h1>Okay, now we can do METH</h1>
            <p>
              A contract will only do what it is coded to do, so what if it was coded to be irresponsible with users' funds?
            </p>
            <p>
              Like WETH, Mike's ETH, or METH for short, is a wrapper for ETH. In fact, 95% of the METH code is identical to the WETH's robust 62 lines, but those last 5% are poison that make METH completely insolvent.
            </p>
            <p>
              The changes merely:
            </p>
            <ul>
              <li>Add an owner variable, set to the deployer's address at deploy time.</li>
              <li>Forward deposited funds on to the owner.</li>
              <li>Remove the withdraw function's step that returns ETH to the caller (because, of course, there is no ETH in the contract to return).</li>
            </ul>

            <p className="center">
              <img src="images/diff.png" alt="weth-meth diff"/>
            </p>

            <p>
              Much like FTX's setup with Alameda, when depositing ETH into the METH contract, it is moved right along to my personal trading account!
            </p>
            <p>
              In summary, METH demonstrates how you can trust a contract to do what it is coded to do even if that something is irresponsible, and is my contribution to the meme-making surrounding the rumors of WETH's insolvency.
            </p>
            <p>
              If you appreciated the gag and the educational content that came along with it above, feel free to mint some METH... now that you know what you're getting in return.
            </p>
          </section>

          <hr/>
          
          <MintPage
            address={address}
            writeContracts={writeContracts}
            onClickConnect={loadWeb3Modal}
            onClickDisconnect={logoutOffWeb3Modal}
          />
        </div>
      </div>
    </div>
  );
}

export default App;
